export const NEW_SUBSCRIBER = () => {
    return {
        id: 0,
        name: '',
        email: '',
    }
}

export const NEW_USER = () => {
    return {
        id: 0,
        name: '',
        active: true,
        email: '',
        permissions: [],
        role: null,
    }
}

export const NEW_CLEARANCE_STOCK = () => {
    return {
        id: 0,
        name: '',
        email: '',
        phone: '',
        company_name: '',
        company_position: '',
        country: '',
        product_type: '',
        overstock_reason: '',
        overstock_reason_other: '',
        quantity: 0,
        products_catalogue: '',
    }
}

export const NEW_CUSTOMER_QUESTION = () => {
    return {
        id: 0,
        email: '',
        city: '',
        feedback: ''
    }
}

export const NEW_JOB_APPLY = (locales = []) => {
    return {
        id: 0,
        name: '',
        email: '',
        phone: '',
        find_out: '',
        cv: '',
        other_details: ''
    }
}
